module.exports = __webpack_public_path__ + "static/img/pitch_blue_HQ.6f63787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_blue_HQ.png
// module id = xxDF
// module chunks = 94